
const courses = [
  { name: 'Certification on TDS', students: 0 },
  { name: 'TallyEssential Level 1', students: 0 },
  { name: 'TallyEssential Level 2', students: 7 },
  { name: 'TallyEssential Level 3', students: 16 },
  { name: 'TallyEssential Comprehensive', students: 74 },
  { name: 'TallyProfessional', students: 0 },
  { name: 'TCT', students: 0 },
  { name: 'TallyEssential Comprehensive with GST Simulation', students: 0 },
  { name: 'GST Using TallyPrime with GST Simulation', students: 0 },
  { name: 'GST Simulation', students: 0 },
  { name: 'TallyEssential Comprehensive with Internship', students: 0 },
  { name: 'TallyEssential Level 2 Internship Standalone', students: 0 },
  { name: 'TallyEssential Comprehensive  Internship Standalone', students: 3 },
  { name: 'TallyEssential Level 1 Internship Standalone', students: 0 },
  { name: 'TallyEssential Level 3 Internship Standalone', students: 0 },
  { name: 'GST Accounting Using TallyPrime', students: 0 },
  { name: 'Financial Accounting with GST Taxation', students: 0 },
  { name: 'TDL', students: 0 },
  { name: 'Office Automation', students: 0 },
  { name: 'Complete Guide to Payroll and Income Tax', students: 0 },
  { name: 'Complete Guide to Inventory Management', students: 0 },
  { name: 'GCC VAT Compliance Using TallyPrime', students: 0 },
];

const EContentCourses = () => {
  const fnLoginEContent = (id) => {
    // Placeholder for launch button click handler
    alert(`Launch E-Content clicked with id: ${id}`);
  };

  return (
    <div
      id="mainContentContainer"
      className="nrmlBody"
      style={{ borderLeft: '0px solid rgb(221, 221, 221)' }}
    >
      <div className="loader" style={{ display: 'none' }}>
        <center>
          <div className="loading-image"></div>
        </center>
      </div>
      <div id="idContainer" style={{ width: '96%' }}>
        <div style={{ margin: '20px' }}>
          <div className="titlediv" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div className="d-flex context">List of E-content courses</div>
            <div className="btnright">
              <button
                className="dropbtn"
                style={{ backgroundColor: '#90b732', color: 'white', border: 'none', padding: '8px 16px', cursor: 'pointer' }}
                id="openEcontBtn"
                onClick={() => fnLoginEContent(1)}
              >
                Launch E-Content
              </button>
            </div>
          </div>
          <div className="main-accordian-wrapper-new2" style={{ marginTop: '20px', display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
            {courses.map((course, index) => (
              <div
                key={index}
                className="card_rectangle"
                style={{
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  padding: '8px',
                  width: '250px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  backgroundColor: '#f9f9f9',
                }}
              >
                <a href="#" style={{ marginBottom: '6px' }}>
                  <img
                    src="bluebook.png"
                    alt="Course Icon"
                    style={{ margin: '8px 6px 2px 9px', width: '32px', height: '32px' }}
                  />
                </a>
                <div className="course_name" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                  {course.name}
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <a href="#" style={{ marginRight: '8px' }}>
                    <img
                      src="../images/student_group.png"
                      alt="Students Icon"
                      style={{ margin: '-2px 15px 0 0', display: 'flex', order: 1, width: '24px', height: '24px' }}
                    />
                  </a>
                  <span className="student_count">{course.students} Students</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EContentCourses;
